import styled from "styled-components";

export const SchoolCalendarSectionSection = styled.div.attrs({
  className: "flex min-w-0 flex-wrap gap-2",
})``;

export const SchoolCalendarSectionSectionSecondary = styled.div<{ $tight?: boolean }>`
  margin-top: ${({ $tight }) => ($tight ? "0.75rem" : "2rem")};
`;
